const getYear = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const txtDate = document.querySelector('.year')
    const dateNow = new Date()
    txtDate.textContent = dateNow.getFullYear()
  })
}

export default getYear
